"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericPlace = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const MapObject_1 = require("./MapObject");
/**
 * A generic point location on a map
 */
class GenericPlace extends MapObject_1.MapObject {
    constructor(attributes = {}, isNew = true, collectionManager) {
        super(attributes, isNew, collectionManager);
    }
}
exports.GenericPlace = GenericPlace;
exports.default = GenericPlace;
//# sourceMappingURL=GenericPlace.js.map